export enum ViewMode {
  mainData = 'mainData',
  pads = 'pads',
}

export enum SidebarMode {
  view = 'view',
  edit = 'edit',
}
